import React from 'react';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 px-4 bg-gradient-to-b from-orange-50 to-white overflow-hidden" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-700 px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide mb-4 animate-pulse" data-id="element-4">
            <Gift size={16} data-id="element-5" />
            Regalos exclusivos
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-6">
            Llevate estos Bonus <span className="text-orange-600" data-id="element-7">GRATIS</span>
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-8">
            Solo disponibles por el día de hoy con tu compra
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-9">
          {/* Bonus 1 */}
          <div className="group cursor-pointer" onClick={scrollToPurchase} data-id="element-10">
            <div className="relative transform transition-all duration-300 group-hover:-translate-y-2" data-id="element-11">
              <div className="absolute -inset-1 bg-gradient-to-r from-orange-400 to-red-400 rounded-2xl blur opacity-20 group-hover:opacity-40 transition duration-200" data-id="element-12"></div>
              <img src="https://cdn.magicpatterns.com/uploads/vnZmLJGUKjKTrq5JZtwjwQ/BONO_1_TDLO.png" alt="Bono 1: Banco de Actividades Rápidas" className="relative rounded-xl shadow-xl w-full border border-orange-100" data-id="element-13" />
              <div className="absolute top-4 right-4 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg" data-id="element-14">
                HOY GRATIS CON TU COMPRA!
              </div>
            </div>
            <div className="mt-6 text-center" data-id="element-15">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-16">
                Bonus #1: Actividades "Salva-Clases"
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-17">
                Banco de actividades rápidas para emergencias, suplencias o días
                complicados. Sin fotocopias, sin preparación.
              </p>
              <span className="inline-block mt-3 text-green-600 font-bold bg-green-50 px-3 py-1 rounded border border-green-100" data-id="element-18">
                HOY GRATIS
              </span>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="group cursor-pointer" onClick={scrollToPurchase} data-id="element-19">
            <div className="relative transform transition-all duration-300 group-hover:-translate-y-2" data-id="element-20">
              <div className="absolute -inset-1 bg-gradient-to-r from-blue-400 to-indigo-400 rounded-2xl blur opacity-20 group-hover:opacity-40 transition duration-200" data-id="element-21"></div>
              <img src="https://cdn.magicpatterns.com/uploads/1ZacpTsHMqpFiMXun2Yu62/BONO_2_TDLO.png" alt="Bono 2: Evaluaciones Listas" className="relative rounded-xl shadow-xl w-full border border-blue-100" data-id="element-22" />
              <div className="absolute top-4 right-4 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg" data-id="element-23">
                HOY GRATIS CON TU COMPRA!
              </div>
            </div>
            <div className="mt-6 text-center" data-id="element-24">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-25">
                Bonus #2: Pack de Evaluaciones
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-26">
                Evaluaciones y recuperatorios listos para usar con rúbricas
                claras. Versión A y B por módulo.
              </p>
              <span className="inline-block mt-3 text-green-600 font-bold bg-green-50 px-3 py-1 rounded border border-green-100" data-id="element-27">
                HOY GRATIS
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}